<template>
    <ContentOrLoading style="min-height: 200px;">
        <b-row v-if="! loading">        
            <b-col md="6" sm="12">
                <b-card>
                    <h3>Recaudación agrupada por precios.</h3>
                    <b-table striped hover :items="recaudacionPrecios">
                        <template #cell(importe)="data">
                            {{ data.value | formatear_precio }}
                        </template>
                    </b-table>
                </b-card>
            </b-col>
            <b-col md="6" sm="12">
                <b-card>
                    <h3>Gráfica de recaudación agrupada por precios.</h3>
                    <GChart
                        type="PieChart"
                        :data="chartData"
                        :options="{
                            height: 400,
                            chartArea:{width:'100%'}
                        }"
                    />
                </b-card>
            </b-col>    
        </b-row>
    </ContentOrLoading>
</template>

<script>
    export default {
        props: ['lista_id'],
        data() {
            return {
                loading: true,
                recaudacionPrecios: null
            }
        },
        created() {
            this.getInformeRecaudacionPrecios();
        },
        computed: {
            chartData() {
                let data = [
                    ['precio', 'importe']
                ];

                if(this.recaudacionPrecios) {
                    let array_prices = this.recaudacionPrecios.slice();
                    array_prices.pop();

                    array_prices.forEach(precio => {
                        if (precio.importe >= 0) {
                            data.push([
                                precio.precio, parseFloat(precio.importe)
                            ]);
                        }
                    });
                }

                return data;
            }
        },
        methods: {
            getInformeRecaudacionPrecios() {
                const params = {
                    filters: {},
                    lista_id: this.lista_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.desglose-ventas.recaudacion-precios'), params).then(res => {
                    this.recaudacionPrecios = res.data.data;
                }).finally(() => this.loading = false);
            },
        }
    }
</script>